var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.$store.getters.getPackage != 'premium' && _vm.value)?[_c('span',{staticClass:"label label-info"},[_vm._v("PREMIUM")])]:(_vm.$store.getters.getPackage == 'premium' && _vm.value)?[_vm._t("default")]:[_vm._v("-")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e8a4384","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/dashboard/CustomerItemValue.vue
// module id = null
// module chunks = 